/**
 * @Author: Ygm
 * @Date: 2024-08-07 09:06:20
 * @LastEditors: Ygm
 * @LastEditTime: 2025-07-10 16:52:52
 * @Description: 信息转办 -> 录入空间
 */
const defaultRouters = [
  {
    name: 'InfoEntry',
    path: '/infoInput/entry',
    title: '信息录入',
    component: () => import('@/view/pages/InputSpace/InfoEntry')
  },
  {
    name: 'EntryStatistics',
    path: '/infoInput/entryStatistics',
    title: '录入统计',
    component: () => import('@/view/pages/InputSpace/EntryStatistics')
  },
  {
    name: 'InfoRelease',
    path: '/infoInput/release',
    title: '信息发布',
    component: () => import('@/view/pages/InputSpace/InfoRelease')
  },
  {
    name: 'EntryStaff',
    path: '/infoInput/entryStaff',
    title: '临时录入人员',
    component: () => import('@/view/pages/InputSpace/EntryStaff')
  },
  {
    name: 'EntryDetails',
    path: '/infoInput/entryDetails',
    title: '信息录入详情',
    component: () => import('@/view/pages/InputSpace/InfoDetails/EntryDetails')
  },
  {
    name: 'TransferDetails',
    path: '/infoInput/transferDetails',
    title: '信息转办详情',
    component: () => import('@/view/pages/InputSpace/InfoDetails/TransferDetails')
  },
  {
    name: 'InfoCategory',
    path: '/infoInput/infoCategory',
    title: '信息类别',
    component: () => import('@/view/pages/InputSpace/InfoCategory')
  }
]

export default defaultRouters



// WEBPACK FOOTER //
// ./src/router/inputSpace.js